
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'ไปที่หน้ายินดีต้อนรับ',


	'widgetsListLabel': 'รายการวิดเจ็ต เลือกวิดเจ็ต และกด enter เพื่อเพิ่ม',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'อัพเดทล่าสุด',
	'dirty': 'ไม่ได้อัพเดตล่าสุด',
	'conflict': 'เกิดความขัดแย้งการบันทึกมุมมอง',
	'error': 'ปัญหาการบันทึกมุมมอง',
	'failure': 'ไม่สามารถติดต่อกับเซิร์ฟเวอร์',
	'saveFailed': 'ไม่สามารถบันทึกมุมมอง',

	'wa_insync': 'บันทึกแล้ว',
	'wa_conflict': 'เกิดความขัดแย้งการบันทึกมุมมอง',
	'wa_error': 'ไม่สามารถบันทึกมุมมอง',
	'wa_failure': 'ไม่สามารถติดต่อกับเซิร์ฟเวอร์',

	// Menu Labels
	'changeDisplay': 'เปลี่ยนการแสดงผล',
	'changeToColumnChart': 'เปลี่ยนเป็นแผนภูมิคอลัมน์',
	'changeToBubbleChart': 'เปลี่ยนเป็นแผนภูมิบับเบิล',
	'toggleMoveHandles': 'สลับตัวจับย้าย',
	'undo': 'เลิกทำ',
	'redo': 'ทำซ้ำ',
	'mode': 'เปลี่ยนโหมด',

	'untitled': 'ไม่มีชื่อเรื่อง',
	'remove': 'ลบออก',
	'editTitle': 'แก้ไขหัวเรื่อง',
	'edit': 'แก้ไข',
	'done': 'เสร็จสิ้น',

	// Data tray
	'dataTrayHandleOpenLabel': 'เปิดถาดข้อมูล',
	'dataTrayHandleCloseLabel': 'ปิดถาดข้อมูล',

	// Dialogs
	'dlg_loading': 'กำลังโหลด...',
	'dlg_ok': 'ตกลง',
	'dlg_create': 'สร้าง',
	'dlg_cancel': 'ยกเลิก',
	'dlg_close': 'ปิด',
	'dlg_update': 'อัพเดต',
	'dlg_renameBoardTitle': 'เปลี่ยนชื่ออ็อบเจ็กต์',
	'dlg_renameDatasetTitle': 'เปลี่ยนชื่อชุดข้อมูลนี้',
	'dlg_renameSceneTitle': 'เปลี่ยนชื่อฉากนี้',
	'dlg_NameLabel': 'ชื่อ:',
	'dlg_NewNameLabel': 'ชื่อใหม่:',
	'dlg_DefaultNameWithDataSet': 'มุมมอง %{name}',
	'dlg_ShareTitle': 'แบ่งใช้เนื้อหา',
	'dlg_UnshareTitle': 'ลบการแบ่งใช้เนื้อหา',
	'dlg_ShareUser': 'ID ผู้ใช้:',
	'dlg_NewColumnLabel': 'ชื่อการคำนวณใหม่',

	'dlg_new': 'สร้าง...',
	'dlg_open': 'เปิด...',
	'dlg_makeACopy': 'ทำสำเนา',
	'dlg_rename': 'เปลี่ยนชื่อ...',
	'dlg_moreToCome': 'แอ็คชันเพิ่มเติมกำลังมา...',

	'dlg_use': 'ใช้',

	'dlg_RelinkDatasetTitle': 'แทนที่ชุดข้อมูล \'%{datasetName}\' ด้วย ...',

	'open_error': 'เกิดปัญหาขณะเปิดมุมมอง',

	// Delete Board
	'del_dialogTitle': 'ยืนยันการลบ',
	'del_itemMsg': 'คุณแน่ใจว่าต้องการที่จะลบ \'%{name}\' หรือไม่?',
	'del_itemsMsg': 'คุณแน่ใจว่าต้องการที่จะลบ %{count} ไอเท็มหรือไม่?',
	'del_deleteErr': 'ไม่สามารถลบ \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'จากน้อยไปมาก',
	'dlg_descending': 'จากมากไปน้อย',
	'dlg_custom': 'กำหนดเอง',
	'dlg_none': 'ไม่มี',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'ค้นหา',

	'searchHint': 'ค้นหาข้อมูลของคุณทั้งหมด',
	'clearSearchResult': 'ล้างผลลัพธ์การค้นหา',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'วงกลม',
	'shapesHexagon': 'รูปหกเหลี่ยม',
	'shapesLine': 'เส้น',
	'shapesOctagon': 'รูปแปดเหลี่ยม',
	'shapesPentagon': 'รูปห้าเหลี่ยม',
	'shapesSquare': 'สี่เหลี่ยมจตุรัส',
	'shapesTriangle': 'สามเหลี่ยม',
	'shapesDiamond': 'ไดมอนด์',
	'shapesTitle': 'คุณสมบัติของรูปทรง', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'สี่เหลี่ยมจตุรัสมุมมน',
	'shapesStar': 'ดาว',
	'shapesChevron': 'เชฟรอน',
	'shapesBadge_ribbon': 'ป้ายริบบิ้น',
	'shapesBadge': 'ป้าย',
	'shapesHeart': 'รูปหัวใจ',
	'shapesExclamation': 'เครื่องหมายตกใจ',
	'shapesTrendingup': 'แนวโน้มขึ้น',
	'shapesTrendingdown': 'แนวโน้มลง',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'ผู้คน',
	'shapesFemale': 'ผู้หญิง',
	'shapesHappyface': 'หน้ายิ้ม',
	'shapesMale': 'ผู้ชาย',
	'shapesMan': 'ผู้ชาย',
	'shapesNeutralface': 'หน้าปกติ',
	'shapesSadface': 'หน้าร้องไห้',
	'shapesShakehands': 'จับมือ',
	'shapesThumbsdown': 'หัวแม่โป้งชี้ลง',
	'shapesThumbsup': 'หัวแม่โป้งชี้ลง',
	'shapesWoman': 'ผู้หญิง',

	// Weather and places
	'shapesPlacesWeatherCat': 'สถานที่ & อากาศ',
	'shapesCity': 'เมือง',
	'shapesCloud': 'เมฆ',
	'shapesEducation': 'การศึกษา',
	'shapesGovernment': 'ราชการ',
	'shapesHalfcloud': 'เมฆครึ่งเดียว',
	'shapesHouse': 'บ้าน',
	'shapesMoon': 'พระจันทร์',
	'shapesRain': 'ฝน',
	'shapesSunny': 'พระอาทิตย์',

	//Vehicles
	'shapesVehiclesCat': 'ยานพาหนะ',
	'shapesAirplane': 'เครื่องบิน',
	'shapesCar': 'รถยนต์',
	'shapesShip': 'เรือ',
	'shapesShoppingcart': 'รถเข็น',
	'shapesTrain': 'รถไฟ',
	'shapesTruck': 'รถบรรทุก',

	//Objects
	'shapesObjectsCat': 'อ็อบเจ็กต์',
	'shapesBook': 'หนังสือ',
	'shapesBriefcase': 'กระเป๋าเอกสาร',
	'shapesCalendar': 'ปฏิทิน',
	'shapesCheck': 'เช็ค',
	'shapesClock': 'นาฬิกา',
	'shapesDesktop': 'เดสก์ท็อป',
	'shapesDocument': 'เอกสาร',

	'shapesFood': 'อาหาร',
	'shapesGear': 'เฟือง',
	'shapesHealth': 'สุขภาพ',

	'shapesIdea': 'ความคิด',
	'shapesMobile': 'เคลื่อนย้ายได้',
	'shapesMoney_bill': 'เงินธนบัตร',
	'shapesMoney_coin': 'เงินเหรียญ',
	'shapesPiggybank': 'กระปุกออมสิน',
	'shapesStackofpaper': 'กองกระดาษ',
	'shapesStickynote1': 'โน๊ตติดกาว 1',
	'shapesStickynote2': 'โน๊ตติดกาว 2',
	'shapesTarget': 'เป้าหมาย',
	'shapesTool': 'เครื่องมือ',

	'shapesUmbrella': 'ร่ม',

	'shapesBrain': 'สมอง',
	'shapesSkull': 'กะโหลกศีรษะ',
	'shapesEye': 'ตา',

	// Arrows shapes
	'shapesArrowsCat': 'ลูกศร',
	'shapesRightArrow': 'ลูกศรทางขวา',
	'shapesLeftArrow': 'ลูกศรทางซ้าย',
	'shapesDoubleArrow': 'ลูกศรคู่',
	'shapesCurvedArrow': 'ลูกศรโค้ง',

	// Callouts shapes
	'shapesCalloutsCat': 'กรอบคำพูด',
	'shapesRectCallout': 'กรอบคำพูด',

	// Images
	'imagesCat': 'รูปภาพ',
	'imageWidgetTitle': 'วิดเจ็ตอิมเมจ',
	'imgUrl': 'URL รูปภาพ',
	'noImgSelected': 'ไม่ได้เลือกอิมเมจไว้',
	'enterImgUrl': 'ป้อน URL ขิงอิมเมจที่นี่',
	'imgPasteLink': 'วาง URL และกด Enter เพื่อบันทึก',
	'imgResizeToFit': 'ปรับขนาดให้พอดีกับขนาดของรูปภาพ',
	'imgHeight': 'ความสูง:',
	'imgWidth': 'ความกว้าง:',
	'imgTransparency': 'ความโปร่งใส:',
	'imgMissingUrl': 'URL ของอิมเมจหายไป',
	'imgUrlValidationError': 'URL ของอิมเมจไม่ถูกต้อง',
	'imgUrlInvalidDomainError': 'URL อิมเมจชี้ไปยังโดเมนที่ไม่ได้รับการอนุมัติโดยผู้ดูแลระบบของคุณ โดเมนที่ได้รับอนุมัติโดยผู้ดูแลระบบของคุณคือ "%{domains}"',

	// line shape
	'propStrokeWidth': 'ความหนาของเส้น',
	'propStrokeDashArray': 'สไตล์ของเส้น',
	'propStrokeSolidline': 'เส้นทึบ',
	'propStrokeLineCap': 'ลักษณะปลายเส้น',
	'propStrokeLineCapButt': 'ปุ่ม',
	'propStrokeLineCapRound': 'วงกลม',
	'propStrokeLineCapSquare': 'สี่เหลี่ยมจัตุรัส',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'เล่น',
	'dataPlayerValueListLabel': 'ค่าของเครื่องเล่นข้อมูล',
	// Text Widget
	'textWidgetTitle': 'วิดเจ็ตข้อความ',
	'textStyle': 'สไตล์',
	'textStyleDescription': 'สไตล์ข้อความที่จัดรูปแบบไว้ล่วงหน้า',
	'textTitleStyle': 'หัวเรื่อง',
	'textTitleSmallStyle': 'หัวเรื่องขนาดเล็ก',
	'textSubtitleStyle': 'หัวเรื่องย่อย',
	'textBodyStyle': 'เนื้อความ',
	'textBodySmallStyle': 'เนื้อความขนาดเล็ก',
	'textCaptionStyle': 'คำบรรยาย',
	'textQuoteStyle': 'การอ้างอิง',
	'textQuoteSmallStyle': 'การอ้างอิงขนาดเล็ก',
	'textResponsiveStyle': 'ปรับขนาดอัตโนมัติ',
	'textAutoFontSize': 'อัตโนมัติ',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'เส้นบางเฉียบ',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'บางเอียง',
	'textFontFamilySubClassExtraLight': 'บางพิเศษ',
	'textFontFamilySubClassExtraLightItalic': 'บางเอียงพิเศษ',
	'textFontFamilySubClassLight': 'อ่อน',
	'textFontFamilySubClassLightItalic': 'บางเอียง',
	'textFontFamilySubClassRegular': 'ปกติ',
	'textFontFamilySubClassRegularItalic': 'เอียงปกติ',
	'textFontFamilySubClassItalic': 'ตัวเอียง',
	'textFontFamilySubClassMedium': 'กลาง',
	'textFontFamilySubClassMediumItalic': 'ตัวเอียงขนาดกลาง',
	'textFontFamilySubClassHeavy': 'ตัวหนา',
	'textFontFamilySubClassHeavyItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassDemiBold': 'ตัวหนาครึ่งหนึ่ง',
	'textFontFamilySubClassDemiBoldItalic': 'ตัวเอียงหนาครึ่งหนึ่ง',
	'textFontFamilySubClassBold': 'ตัวหนา',
	'textFontFamilySubClassBoldItalic': 'ตัวเอียงหนา',
	'textFontFamilySubClassExtraBold': 'ตัวหนาพิเศษ',
	'textFontFamilySubClassExtraBoldItalic': 'ตัวเอียงหนาพิเศษ',
	'textFontFamilySubClassBlack': 'สีดำ',
	'textFontFamilySubClassBlackItalic': 'ตัวเอียงสีดำ',
	'textFontFamilySubClassStencil': 'สเตนซิล',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'ฟอนต์แบบปรับขนาดอัตโนมัติ',
	'responsiveCoachmarkContents': 'ขนาดฟอนต์จะปรับขนาดให้เหมาะสมแบบอัตโนมัติเมื่อคุณปรับขนาดชนิดข้อความนี้ คุณสามารถตั้งค่าขนาดฟอนต์ในคุณสมบัติเท็กซ์',

	'propText': 'รายละเอียดของข้อความ', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'คุณสมบัติของข้อความ', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'ขนาดของฟอนต์',
	'textFontFamily': 'ตระกูลของฟอนต์',
	'textFontWeight': 'ขนาดฟอนต์', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'ลิงก์รูปภาพ',
	'propMissingURL': 'ป้อน URL',
	'propImgTop': 'คุณสมบัติของรูปภาพ', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'คุณสมบัติทั่วไป', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'ทั่วไป', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'ทั่วไป', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'เติมสี', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'สีข้อความ', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'สีของเส้นขอบ',
	'propMaintainAxisScales': 'รักษาสเกลของแกน',
	'propShowItemLabel': 'แสดงเลเบลของไอเท็ม',
	'propHideLegend': 'ซ่อนคำอธิบายสัญลักษณ์',
	'propColorPalette': 'ถาด',
	'propLegendPosition': 'ตำแหน่งของคำอธิบายสัญลักษณ์',
	'propHideAxisTitleLabels': 'ซ่อนชื่อแกน',
	'propLineColor': 'สีของเส้น',
	'propBubbleColor': 'สีของบับเบิล',
	'propInterpolation': 'เส้นแบบเรียบ',
	'propElementColor': 'สีอิลิเมนต์ของวิชวลไลเซชัน',
	'propSymbolShape': 'รูปทรงสัญลักษณ์',
	'propHeatScalePalette': 'ลำดับของสี',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'สีเข้มแสดงค่าที่น้อยกว่า',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'สีเข้มแสดงค่าที่มากกว่า',
	'propImageDetails': 'รายละเอียดของรูปภาพ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'รายละเอียดของเว็บเพจ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'รายละเอียดของสื่อบันทึก', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'ป้อน URL และกด Enter',

	//Layout Properties
	'sectionName_positionAndStyle': 'ตำแหน่ง & สไตล์',
	'propPositionLabel': 'ตำแหน่ง', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'ขนาด', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'ความกว้าง',
	'propResizeHeight': 'ความสูง',
	'propRotateLabel': 'หมุน',
	'propRotateAngle': 'มุม', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'จำนวนของไอคอน',
	'propScaleDescription': 'เลือกจำนวนของไอคอน',
	'propScaleFew': 'ต่ำ',
	'propScaleDefault': 'ดีฟอลต์',
	'propScaleMany': 'สูง',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'ค่านี้ต้องเป็นตัวเลข',

	'mediaAriaLabel': 'url อินพุต',
	'dropdownAriaLabel' : 'ดร็อปดาวน์',
	'ariaGroupLabel': 'หมวดหมู่รายการดร็อปดาวน์: %{cateoryLabel} ไอเท็ม: %{itemLabel} กดปุ่ม DOWN เพื่อขยาย กดปุ่ม UP และ DOWN เพื่อนำทาง หรือกดปุ่ม ESCAPE เพื่อยุบ',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'รีเฟรชล่าสุด: %{timeInterval} ที่ผ่านมา',
	'widgetTimer': 'จับเวลาวิดเจ็ต',

	// Theme colors
	'transparent': 'ไม่มีสี',
	'white': 'สีขาว',
	'lightGrey': 'สีเทาอ่อน',
	'grey': 'สีเทา',
	'darkGrey': 'สีเทาเข้ม',
	'black': 'สีดำ',
	'lightBlue': 'สีฟ้าอ่อน',
	'blue': 'สีน้ำเงิน',
	'darkBlue': 'สีน้ำเงินเข้ม',
	'yellow': 'สีเหลือง',
	'orange': 'สีส้ม',
	'lime': 'สีเขียวมะนาว',
	'green': 'สีเขียว',
	'peach': 'สีพีช',
	'red': 'สีแดง',
	'violet': 'สีไวโอเล็ต',
	'aqua': 'สีอะควา',
	'purple': 'สีม่วง',
	'plum': 'สีพลัม',
	'gray10': 'สีเทา 10',
	'gray20': 'สีเทา 20',
	'gray30': 'สีเทา 30',
	'gray50': 'สีเทา 50',
	'gray60': 'สีเทา 60',
	'gray70': 'สีเทา 70',
	'gray80': 'สีเทา 80',
	'gray90': 'สีเทา 90',
	'gray100': 'สีเทา 100',
	'blue50': 'สีน้ำเงิน 50',
	'blue60': 'สีน้ำเงิน 60',
	'blue70': 'สีน้ำเงิน 70',
	'green40': 'สีเขียว 40',
	'green50': 'สีเขียว 50',
	'red50': 'สีแดง 50',
	'red60': 'สีแดง 60',


	//Theme Palette Label
	'paletteLabel': 'พาเล็ต IBM %{number}',
	'heatPaletteLabel': 'พาเล็ตฮีท IBM %{number}',
	'conditionalPaletteLabel': 'พาเล็ตแบบมีเงื่อนไข IBM %{number}',
	'carbonPaletteXLight': 'คาร์บอน X สีจาง',
	'carbonPaletteXDark': 'คาร์บอน X สีเข้ม',
	'carbonPalettePurple': 'สีม่วง',
	'carbonPaletteTeal': 'สีน้ำเงินอมเขียว',
	'carbonPaletteCyan': 'สีฟ้า',
	'carbonPaletteMagenta': 'สีม่วงแดง',
	'carbonPalettePurpleTeal': 'สีม่วง สีน้ำเงินอมเขียว',
	'carbonPaletteCyanMagenta': 'สีฟ้าอมเขียว สีม่วงแดง',
	'carbonPaletteGreenRed': 'สีเขียว สีแดง',
	'carbonPaletteGreenYellowRed': 'สีเขียว สีเหลือง สีแดง',
	'carbonPalettePurpleTealConvergent': 'การรวม สีม่วง สีน้ำเงินอมเขียว',
	'carbonPaletteCyanMagentaConvergent': 'การรวม สีฟ้าอมเขียว สีม่วงแดง',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'พาเล็ตไลท์ IBM',
	'userPaletteColor_defaultTheme': 'พาเล็ตดีฟอลต์ของ IBM',
	'userPaletteColor_darkTheme': 'พาเล็ตดาร์ค IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'สีพื้นหลัง',
	'propLayoutPositioning': 'การกำหนดตำแหน่งโครงร่าง',
	'propLayoutRelative': 'สัมพันธ์',
	'propLayoutAbsolute': 'สัมบูรณ์',
	'propLayoutPositioningCoachmarkTitle': 'เลือกสไตล์ของโครงร่าง',
	'propLayoutPositioningCoachmarkContent': 'ในโครงร่างแบบสัมพันธ์ ขนาดและตำแหน่งของวิดเจ็ตจะปรับให้พอดีในหน้าจอ วิดเจ็ตในโครงร่างแบบสัมบูรณ์จะปรากฎตามตามที่คุณปรับขนาดและวางไว้ในมุมมอง โดยไม่คำนึงถึงขนาดหน้าจอ',
	'gridText': 'แสดงกริด',
	'snapText': 'ติดกับเส้นกริด',
	'snapObjectsText': 'ติดกับอ็อบเจ็กต์',
	'fitPageText': 'พอดีกับเพจ',
	'gridLabel': 'กริด',
	'heightUnit': 'ส',
	'widthUnit': 'ก',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'ขนาดเพจ',
	'propPageSizePresetAriaLabel': 'ขนาดเพจที่กำหนดไว้ล่วงหน้า',
	'propPageSizePreset': 'ตั้งไว้ล่วงหน้า',
	'propPageSizePresetCustom': 'กำหนดเอง',
	'propPageSizePreset16x9': 'หน้าจอขนาด 16:9',
	'propPageSizePreset4x3': 'หน้าจอขนาด 4:3',
	'propPageSizePresetInfographic': 'อินโฟกราฟิก',
	'propPageSizeWidth': 'ความกว้าง',
	'propPageSizeHeight': 'ความสูง',
	'propPageSizeWidthAriaLabel': 'ความกว้างของขนาดเพจ',
	'propPageSizeHeightAriaLabel': 'ความสูงของขนาดเพจ',
	'propPageSizeAdjustedMessage': 'ขนาดเพจจะเพิ่มขึ้นเนื่องจากค่าที่คุณป้อนน้อยกว่าค่าต่ำสุดหรือไม่พอดีกับแดชบอร์ด',
	'propTabShow': 'แสดงแท็บ',
	'propShowTabsInPreview': 'แสดงแท็บในตัวอย่าง',
	'multilingualDashboardsLabel': 'ภาษา',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- ดีฟอลต์',
	'multilingualDashboardsAddLinkText': 'เพิ่มภาษาอื่น',
	'multilingualDashboardsSelect': 'เลือก',
	'multilingualDashboardsButtonLabel': 'เพิ่ม',
	'multilingualDashboardTranslationMode': 'ตอนนี้คุณอยู่ในโหมดการแปล (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'เสร็จสิ้น',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} คำแปลที่เหลืออยู่',
	'multilingualDashboardRemainingString': 'เหลือ 1 คำแปล',
	'multilingualDashboardsSetDefault': 'ตั้งค่าภาษาดีฟอลต์',
	'multilingualDashboardIconMore': 'แอ็คชันเพิ่มเติมสำหรับภาษา %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'พื้นที่ที่แปลได้',
	'multilingualDeleteTitle': 'ลบภาษา',
	'multilingualDeleteLanguageWarning': 'คุณแน่ใจว่าต้องการลบภาษา \'%{language}\' หรือไม่?',
	'multilingualSelectLanguage': 'เลือกภาษา',
	'confirmLayoutStyleUpgradeTitle': 'ใช้กับแท็บทั้งหมด',
	'confirmLayoutStyleUpgrade': 'ใช้สไตล์ของโครงร่างนี้กับแท็บทั้งหมดในแดชบอร์ดหรือไม่?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'ลบ',
	'tabDeleteDialogTitle': 'ลบแท็บนี้หรือไม่?',
	'tabDeleteDialogMessage': 'เนื้อหาทั้งหมดในแท็บนี้จะถูกลบออกด้วย',

	// Vis widget
	'propVisTypeReturn': 'ชนิดของวิชวลไลเซชัน',
	'propVisDetails': 'รายละเอียด',

	// Alignment picker
	'propAlignPickTop': 'จัดวางชิดด้านบน',
	'propAlignPickRight': 'จัดวางชิดขวา',
	'propAlignPickBottom': 'จัดวางชิดด้านล่าง',
	'propAlignPickLeft': 'จัดวางชิดซ้าย',
	'propAlignPickCenter': 'จัดวางไว้กึ่งกลาง',
	'propAlignPicker': 'การจัดวาง',

	// Toolbar picker
	'propToolbarPickBold': 'ตัวหนา',
	'propToolbarPickUnderline': 'ขีดเส้นใต้',
	'propToolbarPickItalic': 'ตัวเอียง',
	'propToolbarPickJustifyLeft': 'จัดวางชิดซ้าย',
	'propToolbarPickJustifyCenter': 'จัดวางไว้กึ่งกลาง',
	'propToolbarPickJustifyRight': 'จัดวางชิดขวา',
	'propToolbarPickJustify': 'จัดให้พอดี',

	'propList': 'ลิสต์',
	'propOrderedList': 'รายการแบบเรียงลำดับ',
	'propUnorderedList': 'รายการแบบไม่เรียงลำดับ',

	// Symbol shapes
	'propCircle': 'วงกลม',
	'propTriangle': 'สามเหลี่ยม',
	'propSquare': 'สี่เหลี่ยมจตุรัส',
	'propRect': 'สี่เหลี่ยนผืนผ้า',
	'propStar': 'ดาว',
	'propCross': 'ขวาง',
	'propPlus': 'บวก',
	'propPoly': 'รูปหลายเหลี่ยม',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'ด้านซ้าย',
	'propRight': 'ด้านขวา',
	'propTop': 'บน',
	'propBottom': 'ล่าง',

	// Interpolation options
	'propSmooth': 'เรียบ',
	'propStraight': 'เส้นตรง',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'ลิสต์', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'ย้ายไปทางซ้าย', // screen reader
	'srWidgetMoveUp': 'เลื่อนขึ้น', // screen reader
	'srWidgetMoveRight': 'ย้ายไปทางขวา', // screen reader
	'srWidgetMoveDown': 'เลื่อนลง', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'เพิ่มขนาดตามสัดส่วน', // screen reader
	'srWidgetResizeSmaller': 'ลบขนาดตามสัดส่วน', // screen reader
	'srWidgetResizeBiggerV': 'เพิ่มขนาดในแนวดิ่ง', // screen reader
	'srWidgetResizeSmallerV': 'ลดขนาดในแนวดิ่ง', // screen reader
	'srWidgetResizeBiggerH': 'เพิ่มขนาดในแนวนอน', // screen reader
	'srWidgetResizeSmallerH': 'ลดขนาดในแนวนอน', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'หมุนตามเข็มนาฬิกา', // screen reader
	'srWidgetRotateCCW': 'หมุนทวนเข็มนาฬิกา', // screen reader

	// Recommended types
	'visChange': 'เปลี่ยนวิชวลไลเซชัน',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'วิชวลไลเซชัน',
	'chartLabel': 'แผนภูมิ %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'กด F12 เพื่อนำทางภายในวิดเจ็ต',
	'f10KeyDescription': 'กด F10 เพื่อเรียกทำงานมุมมองโฟกัสวิดเจ็ต',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} ที่มีค่า %{value}',

	'shapeColorLabel': 'สีของรูปทรง',
	'showLegendLabel': 'แสดงคำอธิบายสัญลักษณ์',

	//Webpage
	'webpageWidgetTitle': 'วิดเจ็ตเว็บเพจ',
	'webpagePasteLink': 'วาง URL และกด Enter เพื่อบันทึก',
	'propWebpageLink': 'URL ของเว็บเพจ',
	'propWebpageTitle': 'หัวเรื่องของเว็บเพจ',
	'propWebpageTitleDescription': 'หัวเรื่องของเว็บเพจ',
	'webpageUrl': 'URL ของเว็บเพจ',
	'noWebpageSelected': 'ไม่ได้เลือกเว็บเพจไว้',
	'enterWebpageUrl': 'ป้อน URL ของเว็บเพจที่นี่',
	'propWebpageTop': 'คุณสมบัติของเว็บเพจ', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'URL ของเว็บเพจหายไป',
	'webpageUrlValidationError': 'URL ของเว็บเพจไม่ถูกต้อง',
	'webpageHttpValidationError': 'ต้องเข้าถึงเว็บเพจโดยใช้ลิงก์ HTTPS',
	'webpageInvalidDomainError': 'URL เว็บเพจชี้ไปยังโดเมนที่ไม่ได้รับการอนุมัติโดยผู้ดูแลระบบของคุณ โดเมนที่ได้รับอนุมัติโดยผู้ดูแลระบบของคุณคือ "%{domains}"',

	//VizState
	'vzErrorLoading': 'ไม่สามารถโหลดวิชวลไลเซชัน',
	'vzErrorLoadingMissingData': 'ไม่สามารถโหลดวิชวลไลเซชัน ข้อมูลบริบทหายไป',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'วิดเจ็ตสื่อบันทึก',
	'mediaPasteLink': 'วาง URL และกด Enter เพื่อบันทึก',
	'mediaUrl': 'URL ของสื่อบันทึก',
	'noMediaSelected': 'ไม่ได้เลือกสื่อบันทึกไว้',
	'enterMediaUrl': 'ป้อน URL ของสื่อบันทึกที่นี่',
	'videoHeight': 'ความสูง:',
	'videoWidth': 'ความกว้าง:',
	'propMediaLink': 'ลิงก์สื่อบันทึก',
	'propMediaTitle': 'หัวเรื่องของสื่อบันทึก',
	'propMediaTitleDescription': 'หัวเรื่องของสื่อบันทึก',
	'propMediaTop': 'คุณสมบัติของสื่อบันทึก', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'URL ของสื่อบันทึกหายไป',
	'mediaUrlValidationError': 'URL ของไฟล์สื่อบันทึกไม่ถูกต้อง',
	'mediaUnknownValidationError': 'ไม่สนับสนุนสื่อบันทึกชนิดนี้',
	'mediaHttpValidationError': 'ต้องเข้าถึงไฟล์สื่อบันทึกโดยใช้ลิงก์ HTTPS',
	'mediaInvalidDomainError': 'URL มีเดียไฟล์ชี้ไปยังโดเมนที่ไม่ได้รับการอนุมัติโดยผู้ดูแลระบบของคุณ โดเมนที่ได้รับอนุมัติโดยผู้ดูแลระบบของคุณคือ "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'คุณสมบัติ', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'ชุดข้อมูล',
	'dataViewsLabel': 'มุมมอง',
	'columnQuality': 'คุณภาพของข้อมูล',
	'columnProperties': 'คุณสมบัติของข้อมูล',

	'dataQuality': 'คุณภาพของข้อมูล',
	'dataQualityRowCount': 'จำนวนแถว',
	'dataQualityDistribution': 'การกระจาย',
	'dataRowLabel': 'ข้อมูล',

	// Modelling UI
	'typeColumn': 'ชนิด',
	'modellingColumnType': 'ชนิด',
	'modellingColumnAggregation': 'การรวม',
	'modellingColumnUsage': 'การใช้งาน',
	'modellingColumnSort': 'เรียงลำดับ',
	'modellingColumnFormat': 'รูปแบบ',
	'modellingColumnCategory': 'หมวดหมู่',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'กำลังโหลด...',

	'modellingProcessing': 'กำลังประมวลผล...',
	'modellingImport': 'อิมพอร์ต',
	'modellingReimport': 'อิมพอร์ตอีกครั้ง',
	'modellingDatasourceTitle': 'แหล่งข้อมูล',
	'modellingImportStartedTitle': 'การอิมพอร์ตเริ่มต้นแล้ว',
	'modellingImportStartedText': 'การอิมพอร์ตข้อมูลของคุณอาจใช้เวลาสักครู่\n\n(คุณสามารถสร้างมุมมองได้ขณะที่ข้อมูลถูกอิมพอร์ต)',
	'importDatasourceTitle': 'การเชื่อมต่อ',
	'dropHere': 'ปล่อยที่นี่เพื่อสร้างแหล่งข้อมูลใหม่...',
	'browseButton': 'เรียกดู',
	'errorNoData': 'ไม่มีข้อมูลเพื่อประมวลผล',
	'errorNoFile': 'ไม่มีไฟล์เพื่ออัพโหลด',
	'errorUploadFailed': 'ไม่สามารถอัพโหลด',
	'uploadSucceessful': 'อัพโหลดสำเร็จ',
	'del_datasourceTitle': 'ลบชุดข้อมูล',
	'del_datasourceMsg': 'คุณแน่ใจว่าต้องการลบ \'%{name}\' หรือไม่?',
	'modellingFileUpdate': 'อัพเดต',
	'modellingFileUpdateTitle': 'อัพเดตชุดข้อมูล',
	'modellingFileUpdateDescription': 'คุณแน่ใจว่าต้องการอัพเดต \'%{name}\' หรือไม่?',
	'modellingFileUpdatingTitle': 'กำลังอัพเดต \'%{name}\'',
	'modellingUpdateStartedTitle': 'อัพเดตการอิมพอร์ตเริ่มต้นแล้ว',
	'modellingUpdateStartedText': 'การอัพเดตข้อมูลของคุณอาจใช้เวลาสักครู่\n\n(คุณสามารถสร้างมุมมองได้ขณะที่ข้อมูลถูกอัพเดต)',
	'modellingErrorImportUploadNoFile': 'ไม่มีไฟล์เพื่ออัพโหลด',
	'modellingErrorImportUploadFailed': 'ไม่สามารถอัพโหลด',
	'modellingErrorImportUploadInvalidType': 'ชนิดของไฟล์ไม่ถูกต้อง',
	'modellingErrorImportUploadTableFailed': 'ไม่สามารถได้รับตาราง',
	'modellingIntentResultsTitle': 'เลือกชนิดข้อมูลที่เสนอที่ต้องการใช้',
	'modellingColumnViewRelationships': 'ดูตารางที่เกี่ยวข้อง',
	'modellingTableRelatedTables': 'ตารางที่เกี่ยวข้องกับ \'%{name}\'',
	'modellingTable': '%{name} - ตาราง',
	'modellingColumnIncludedInDataSet': 'ถูกเพิ่ม',
	'modellingDataSet': 'ชุดข้อมูล',
	'modellingViewInDataSet': 'ดูในชุดข้อมูล',
	'modellingViewRelatedTables': 'ดูที่เกี่ยวข้อง',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'ไม่พบตารางที่เกี่ยวข้อง',

	'modellingValidatingDataset': 'กำลังตรวจสอบ...',
	'datasetFinishedRefreshing': 'ชุดข้อมูล %{datasetName} ถูกรีเฟรชแล้ว',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'แก้ไขพาธการรวม:',
	'modellingJoinColumns': 'กำหนดพาธการรวมสำหรับตาราง: %{name}',
	'modellingJoinToTable': 'รวมกับตาราง: %{name}',

	// Data Quality
	'excluded': 'ถูกแยกออก',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'ตัวกรอง',
	'modellingColumnSortNone': 'ล้างการเรียกลำดับ',
	'modellingColumnSortAsc': 'เรียงลำดับจากน้อยไปหามาก',
	'modellingColumnSortDesc': 'เรียงลำดับมากไปหาน้อย',
	'modellingColumnRemove': 'ลบคอลัมน์นี้',

	// Import File Browser
	'dropboxPageTitle': 'การเชื่อมต่อ Dropbox ใหม่',
	'sizeColumn': 'ขนาด',

	//Modelling Column Property Values
	'dataType_string': 'สตริง',
	'dataType_date': 'วันที่',
	'dataType_integer': 'จำนวนเต็ม',
	'dataType_double': 'Double',
	'dataType_float': 'Float',
	'dataType_boolean': 'บูลีน',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'การนับ',
	'defaultAggregation_countdistinct': 'นับที่แตกต่าง',
	'defaultAggregation_max': 'สูงสุด',
	'defaultAggregation_min': 'ต่ำสุด',
	'defaultAggregation_avg': 'เฉลี่ย',
	'defaultAggregation_sum': 'ผลรวม',
	'defaultAggregation_auto': 'อัตโนมัติ (%{aggregationType})',

	'type_fact': 'Fact',
	'type_attribute': 'แอ็ตทริบิวต์',

	'defaultSort_none': 'ห้ามเรียงลำดับ',
	'defaultSort_asc': 'เรียงลำดับจากน้อยไปหามาก',
	'defaultSort_desc': 'เรียงลำดับมากไปหาน้อย',

	'category_none': 'ไม่มี',
	'category_location': 'ที่ตั้ง',
	'category_monetary': 'Monetary',
	'category_time': 'เวลา',

	// Root menu
	'rootMenuTitle': 'เมนูหลัก',

	'errorMessageTitle': 'ข้อผิดพลาด',
	'errorMessageDetails': 'รายละเอียด: ',
	'errorMessageTitleAssetAlreadyExists': 'มีสินทรัพย์อยู่แล้ว',

	'defaultTabTitle': 'แท็บ %{index}',
	'tabAddBtnTitle': 'เพิ่มแท็บใหม่',

	'unsupportedConditionalFormattingEncountered': 'การจัดรูปแบบที่มีเงื่อนไขไม่ถูกนำมาใช้กับบางคอลัมน์อีกต่อไป',


	// Homepage View
	'nameColumn': 'ชื่อ',
	'creatorColumn': 'สร้างโดย',
	'creationDateColumn': 'วันที่สร้าง',
	'versionColumn': 'เวอร์ชัน',
	'modifiedColumn': 'ปรับเปลี่ยนครั้งล่าสุด',

	'filterBy': 'ไอเท็มตัวกรอง',
	'allFilter': 'ไอเท็มทั้งหมด',
	'createdByMeFilter': 'สร้างโดยฉัน',
	'sharedWithMeFilter': 'แบ่งใช้กับฉัน',
	'favoritesFilter': 'รายการโปรดของฉัน',
	'recentsFilter': 'ที่ถูกเพิ่มเมื่อเร็ว ๆ นี้',
	'sortBy': 'เรียงลำดับโดย',

	// Sort Menu
	'sortModified': 'ปรับเปลี่ยน',
	'sortUpdated': 'อัพเดต',
	'sortName': 'ชื่อ',

	'viewAs': 'ดูเป็น',
	'thumbnailsView': 'ดูเป็นรูปขนาดเล็ก',
	'listView': 'ดูเป็นรายการ',
	'createMenu': 'สร้าง',
	'newAppItem': 'แดชบอร์ด',
	'newDataSet': 'ชุดข้อมูล',

	'menuSelectionState_a11y': 'ตัวเลือก "%{item}" ถูกตั้งค่าเป็น "%{selectedItem}"',

	'unableToShareItem': 'ไม่สามารถแบ่งใช้ไอเท็ม "%{item}"',
	'toastFetchingContent': 'ขอรับเนื้อหาเพิ่มเติม...',
	'unableToGetData': 'ไม่สามารถรับเนื้อหา',
	'unableToFavorite': 'ไม่สามารถเปลี่ยนสถานะรายการโปรด',
	'hpErrorMissingRequiredOptions': 'ไม่มีอ็อพชันการเตรียมข้อมูลเบื้องต้นที่ต้องการ',
	'unableToOpenBoard': 'ไม่สามารถเปิด "%{name}"',
	'unableToDuplicateBoard': 'ไม่สามารถทำสำเนา "%{name}"',
	'unableToCreateBoard': 'ไม่สามารถสร้าง "%{name}"',
	'unableToCreateBoardNameConflict': 'มีสินทรัพย์ที่มีชื่อเดียวกันอยู่แล้ว',

	// DataSet Detail View
	'status': 'สถานะ',
	'numberOfRows': 'แถว',
	'importWarnings': 'คำเตือน',
	'lineNumbers': 'บรรทัด',
	'excerptFromSource': 'สิ่งที่ได้',
	'reason': 'สาเหตุ',
	'numberOfRowsDropped': 'แถวที่ถูกดร็อป',
	'oneRowDropped': 'ดร็อป 1 แถว',

	// Type Menu
	'typeMenuLabel': 'ชนิด',
	'dashboardsLabel': 'แดชบอร์ด',
	'datasetsLabel': 'ชุดข้อมูล',
	'storiesLabel': 'เรื่องราว',
	'allLabel': 'ชนิดทั้งหมด',

	// Board Page View App Bar
	'datasets': 'ชุดข้อมูล',
	'settings': 'คุณสมบัติ',
	'add': 'เพิ่ม',
	'widgets': 'วิดเจ็ต',
	'dashboardProperties': 'คุณสมบัติของแดชบอร์ด',
	'searchPanel' : 'ค้นหา',
	'pins': 'คอลเล็กชัน',
	'pinsOld': 'การปักหมุดของฉัน',
	'pinsDateFilterHeading' : 'วันที่ปักหมุด',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} ปักหมุด |||| %{smart_count} ปักหมุด',
	'pinSearch': 'ค้นหา',
	'pinSearchOld': 'ค้นหาการปักหมุด',
	'pinListView': 'มุมมองรายการ',
	'pinIconView': 'มุมมองไอคอน',
	'pinRemove': 'ลบออก',
	'pinCreate': 'สร้าง',
	'pinDeleteError': 'เราไม่สามารถลบสินทรัพย์อย่างน้อยหนึ่งรายการจากคอลเล็กชัน โปรดลองอีกครั้งภายหลัง',
	'pinDeleteErrorOld': 'เราไม่สามารถลบการปักหมุดอย่างน้อยหนึ่งรายการ โปรดลองอีกครั้งภายหลัง',
	'pinRetrieveError': 'เราไม่สามารถดึงการปักหมุดอย่างน้อยหนึ่งรายการ โปรดลองอีกครั้งภายหลัง',
	'NoPinsCollected': 'ไม่มีวิชวลไลเซชันที่ปักหมุดไว้',
	'pinDeletedToast': 'การปักหมุดถูกลบออกแล้ว',
	'pinAddedToast': 'เพิ่มการปักหมุดเข้ากับการปักหมุดของฉันสำเร็จแล้ว',
	'pinningToast': 'กำลังประมวลผลการปักหมุด...',
	'pinDateFilter': 'ตัวกรองวันที่',
	'pinDateFilterAll': 'ทั้งหมด',
	'pinDateFilterToday': 'วันนี้',
	'pinDateFilterYesterday': 'เมื่อวานนี้',
	'pinDateFilterPastWeek': 'สัปดาห์ที่ผ่านมา',
	'pinDateFilterPastMonth': 'เดือนที่ผ่านมา',
	'pinDateFilterEarlier': 'ก่อนหน้า',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'แก้ไขชื่อ',
	'toolbarActionSort': 'เรียงลำดับ',
	'toolbarActionSortAscending': 'เรียงลำดับจากน้อยไปหามาก',
	'toolbarActionSortDescending': 'เรียงลำดับมากไปหาน้อย',
	'toolbarActionSortAuto': 'อัตโนมัติ (%{sortOrder})',
	'toolbarActionFormat': 'จัดรูปแบบข้อมูล',
	'toolbarActionFormatAbbreviation': 'ย่อ',
	'toolbarActionFormatNone': 'อัตโนมัติ',
	'toolbarActionFilter': 'ตัวกรอง',
	'toolbarActionTopBottom': 'ด้านบนหรือด้านล่าง',
	'toolbarActionAddShape': 'เพิ่มรูปร่าง',
	'toolbarActionRmvShape': 'ลบรูปร่าง',
	'toolbarActionToggleShapeDrop': 'รูปร่างอินโฟกราฟิก',
	'toolbarActionToggleShapeDropTitle': 'สร้างอินโฟกราฟิก',
	'toolbarActionToggleShapeDropText': 'ลากรูปร่างไปยังฟิลด์นี้เพื่อสร้างอินโฟกราฟิก',
	'toolbarActionAggregationType': 'การสรุป',
	'toolbarDeleteActionText': 'ลบคอลัมน์',
	'toolbarActionFilterLocalKeepSelected': 'เก็บไว้',
	'toolbarActionFilterLocalExcludeSelected': 'ไม่รวม',
	'toolbarActionFilterAllKeepSelected': 'ตัวกรอง',
	'toolbarActionSimpleCalculation': 'การคำนวณแบบง่าย',
	'toolbarActionDrillBack': 'ย้อนกลับ',
	'toolbarActionDrillUp': 'ดูรายละเอียด',
	'toolbarActionDrillDown': 'ดูโดยละเอียด',
	'toolbarActionNavigate': 'นำทาง',
	'toolbarActionCreateFilterGroup': 'สร้างการเชื่อมต่อใหม่',
	'toolbarActionDisconnectFilterGroup': 'หยุดลิงก์ทั้งหมด',
	'toolbarActionLinkFilterGroup': 'เพิ่มไปยังการเชื่อมต่อที่มีอยู่',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'เพิ่ม',
	'sidebarMultiselect': 'สลับหลายตัวเลือก',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} ที่เลือกไว้',

	'multiselectWithTotalMsg': '%{count} จาก %{total}',
	'sidebarGoBack': 'ย้อนกลับ',

	//DataSet pane
	'errorLoadingDataSets': 'เราไม่สามารถโหลดชุดข้อมูลนี้',
	'errorLoadingDataSetMetaData': 'เราไม่สามารถโหลดชุดข้อมูลนี้',
	'dataSetPaneLastUpdated': 'อัพเดตล่าสุด: %{date}',
	'dataSetPaneDateUnknown': 'ไม่รู้จัก',
	'sourcePaneLabel': 'เลือกแหล่งที่มา',
	'addSourceLabel': 'เพิ่มแหล่งที่มา',
	'find_label': 'ค้นหา',
	'navigationPathsLabel': 'พาธการนำทาง',

	//widgetlist
	'errorLoadingWidgetList': 'เราไม่สามารถโหลดอ็อบเจ็กต์',
	'errorLoadingThemeFile': 'เราไม่สามารถโหลดนิยามธีม',
	'errorLoadingLayoutFile': 'เราไม่สามารถโหลดมุมมอง',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'เราไม่สามารถโหลดนิยามการวิชวลไลเซชันที่มี',

	'dwErrorLoadingVisualizationNotFound': 'เราไม่สามารถโหลดอ็อบเจ็กต์ เนื่องจากไม่มีนิยามวิชวลไลเซชัน',
	'dwErrorLoadingVisualizationListNotFound': 'เราไม่สามารถโหลดวิชวลไลเซชัน',
	'dwErrorRunningQuery': 'เราไม่สามารถดึงข้อมูลจากชุดของข้อมูล %{datasetName}',
	'dwErrorGeoData': 'เรามีปัญหาในการแสดงข้อมูลภูมิศาสตร์ในแม็พ โปรดเลือกชนิดวิชวลไลเซชันอื่น ',
	'dwPromptSignonCancelWarning': 'ไม่มีข้อมูลสำหรับวิชวลไลเซชันนี้ โปรดระบุหนังสือรับรองที่ถูกต้อง',
	'dwErrorMissingDataset': 'เราไม่สามารถโหลดวิชวลไลเซชันได้ เนื่องจากชุดข้อมูลที่เชื่อมโยง \'%{datasetName}\' ไม่พร้อมใช้งาน',
	'dwErrorRenderingVisualization': 'เราไม่สามารถโหลดวิชวลไลเซชันนี้',
	'dwErrorVisualizationTooSmall': 'วิชวลไลเซชันมีขนาดเล็กเกินไปที่จะแสดงข้อมูลที่มี ทำให้วิชวลไลเซชันมีขนาดใหญ่ขึ้นหรือจำกัดจำนวนข้อมูลที่มี',
	'aria_label_datatable': 'ตารางข้อมูล',
	'aria_key_navi_datatable_desc': 'ใช้ปุ่มลูกศรเพื่อนำทางไปยังแต่ละเซลล์ กดปุ่ม Control และ Home เพื่อย้ายไปยังแถวแรก กดปุ่ม Control และ End เพื่อย้ายไปยังแถวสุดท้าย',
	'geomapUnrecognizedLocations': 'ตำแหน่งที่ไม่รู้จัก:',
	'geomapAmbiguousLocations': 'ภูมิภาคที่ไม่ชัดเจน:',

	// custom widget
	'customWidget': 'วิดเจ็ตแบบกำหนดเอง',
	'customWidgetsTitle': 'วิดเจ็ตแบบกำหนดเอง',
	'noCustomWidgets': 'ไม่มีวิดเจ็ตแบบกำหนดเอง',

	// Action names
	'toggleContextBar': 'สลับแถบบริบท',
	'delete': 'ลบ',
	'share': 'แบ่งใช้',
	'unshare': 'ยกเลิกการแบ่งใช้',
	'rename': 'เปลี่ยนชื่อ',
	'close': 'ปิด',
	'duplicate': 'ทำซ้ำ',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'ลองอีกครั้ง',

	'changeTemplate': 'เปลี่ยนเท็มเพลต',

	// Aggregation Types
	'sum': 'ผลรวม',
	'count': 'การนับ',
	'countdistinct': 'นับที่แตกต่าง',
	'avg': 'เฉลี่ย',
	'min': 'ต่ำสุด',
	'max': 'สูงสุด',
	'custom': 'กำหนดเอง',
	'calculated': 'ถูกคำนวณ',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% เปลี่ยนแปลง',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'เกณฑ์ของวิชวลไลเซชัน...',
	'QuickAddResultsHeader': 'วิชวลไลเซชันของข้อมูล',
	'NoQuickAddResults': 'ไม่มีที่ตรงกับที่คุณต้องการ สร้างชุดข้อมูลใหม่หรือไม่',
	'NoQuickAddResultsRetry': 'เราไม่พบคำที่ตรงกัน โปรดลองใช้คำอื่น',
	'templateWidgetTitle': 'เท็มเพลต',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(ว่าง)',

	'nullValueContent': '(ไม่มีค่า)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'ตัวกรองข้อความ - %{columnName}',

	'textFilterSelectTab': 'เลือก',

	'textFilterConditionTab': 'ตั้งค่าเงื่อนไข',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'ไม่มีไอเท็ม',

	'textFilterEquals': 'เท่ากับ',
	'textFilterContains': 'มี',
	'textFilterBeginsWith': 'เริ่มต้นด้วย',
	'textFilterEndsWith': 'ลงท้ายด้วย',
	'textFilterDoesNotEqual': 'ไม่เท่ากับ',
	'textFilterDoesNotContain': 'ไม่มี',
	'textFilterDoesNotBeginWith': 'ไม่เริ่มต้นด้วย',
	'textFilterDoesNotEndWith': 'ไม่ลงท้ายด้วย',
	'textFilterSampleText': 'ตัวอย่างเช่น: A',

	'textFilterAndButton': 'And',
	'textFilterOrButton': 'Or',

	'dateFilterMessage': 'เลือกช่วงของวันที่',
	'dateRangeControlRegionLabel': 'ตัวกรองช่วงวันที่ - %{columnName}',
	'dateFilterRangeOption': 'อ็อพชันช่วง',
	'dateFilterDateLabel': 'วันที่',
	'dateFilterBlank': '(ว่าง)',
	'dateFilterBefore': 'ก่อน',
	'dateFilterAfter': 'หลังจาก',
	'dateFilterBetween': 'ระหว่าง',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'วันที่',
	'dateIncludeBlankLabel': 'รวมวันที่ว่าง',

	'timeTitle': 'เวลา',
	'timeFilterMessage': 'เลือกช่วงของเวลา',
	'dateTimeFilterMessage': 'เลือกช่วงของวันที่และเวลา',

	'topbottomNumberOfResultsLabel': 'จำนวนของผลลัพธ์',
	'topbottomPercentLabel': 'เปอร์เซ็นต์',
	'topbottomNumberOfResultsLimit': 'ระหว่าง %{lower}-%{higher}',
	'topbottomSelectOption': 'อ็อพชันด้านบนหรือด้านล่าง',
	'topbottomOptionLabel': 'แสดง',
	'searchByLabel': 'โดย',
	'searchNoMatches': 'ไม่พบรายการที่ตรงกัน',
	'topbottomRankColumnLabel': 'เพิ่มคอลัมน์การจัดอันดับเข้ากับตาราง',
	'topbottomNone': 'ไม่มี',
	'topCount': 'การนับด้านบน',
	'topPercent': 'ด้านบน %',
	'bottomCount': 'การนับด้านล่าง',
	'bottomPercent': 'ด้านล่าง %',
	'topbottomSearchColumn': 'ค้นหาคอลัมน์',
	'searchColumnAriaLabel': 'ค้นหาคอลัมน์ พิมพ์ชื่อของคอลัมน์ที่จะค้นหา จากนั้น ใช้ลูกศรลงเพื่อค้นหาคอลัมน์ในรายการ',
	'rankColumnLabel': 'อันดับ (%{columnLabel})',
	'topbottomClearLabel': 'เคลียร์',

	'rangeFilterControlRegionLabel': 'ตัวกรองช่วง - %{columnName}',

	// Slider
	'sliderRegionLabel': 'ตัวควบคุมสไลเดอร์ ใช้ลูกศรขวาและซ้ายเพื่อย้ายตัวจัดการสไลเดอร์',
	'sliderHandleLabel': 'ตัวจัดการสไลเดอร์',
	'a11ySliderHandleLabel': 'ตัวจัดการสไลเดอร์ %{sliderValue}',
	'sliderInputLabel': 'ค่า',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'ไอเท็มชุดข้อมูลบางไอเท็มที่ใช้ในวิชวลไลเซชันนี้ไม่พร้อมใช้งาน',
	'datasetItemUnavailable': 'ไอเท็มชุดข้อมูลนี้ไม่พร้อมใช้งาน',

	//Authoring topBottom
	'topOperator': 'บน',
	'bottomOperator': 'ล่าง',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} เทียบกับ %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'อ็อบเจ็กต์นี้เท่านั้น',
	'deleteTopBottom': 'ลบการนับอันดับแรก หรือสุดท้าย',
	'editTopBottom': 'แก้ไขการนับอันดับแรก หรือสุดท้าย',
	'deleteDrillState': 'ลบสถานะการดูรายละเอียดปัจจุบัน',
	'ariaDeleteDrillStateLabel': 'กดปุ่ม ENTER เพื่อแก้ไขการนับอันดับแรกหรือสุดท้าย',
	'drillUpStateTitle': 'เจาะขึ้น',
	'drillDownStateTitle': 'เจาะลง',
	'ariaEditTopBottomLabel': 'กดปุ่ม ENTER เพื่อแก้ไขการนับอันดับแรกหรือสุดท้าย',
	'ariaDeleteTopBottomLabel': 'กดปุ่ม DELETE เพื่อลบการนับอันดับแรกหรือสุดท้าย',

	// Authoring filtering
	'dimFilterIn': 'รวม: %{in}',
	'dimFilterNotIn': 'แยกออก: %{out}',
	'measureFilterBetween': 'ระหว่าง %{lowerBound} และ %{upperBound}',
	'measureFilterNotBetween': 'ไม่อยู่ระหว่าง %{lowerBound} และ %{upperBound}',
	'gtFilter': 'หลังจาก %{lowerBound}',
	'ltFilter': 'ก่อน %{upperBound}',
	'notGtFilter': 'ไม่หลังจาก %{lowerBound}',
	'notLtFilter': 'ไม่ก่อน %{upperBound}',
	'localFilterTitle': 'อ็อบเจ็กต์นี้เท่านั้น',
	'globalFilterTitle': 'อ็อบเจ็กต์ทั้งหมด',
	'deleteFilter': 'ลบตัวกรอง',
	'editFilter': 'แก้ไขตัวกรอง',
	'ariaEditFilterLabel': 'กดปุ่ม ENTER เพื่อแก้ไขตัวกรอง',
	'ariaDeleteFilterLabel': 'กดปุ่ม DELETE เพื่อลบตัวกรอง',

	// Prompts
	'ariaEditPrompt': 'กดปุ่ม ENTER เพื่อเปลี่ยนค่าพร้อมต์',

	'moreDataIndicator': 'ข้อมูลของคุณถูกตัดออกที่ %{threshold} ไอเท็ม ใช้กับตัวกรองเพื่อแสดงข้อมูลให้น้อยลง',

	// data point filtering
	'dataPointFilterTitle': 'จุดข้อมูล',
	'dataPointFilterIncludeSummary': 'รวม %{valueCount} จุดข้อมูล',
	'dataPointFilterExcludeSummary': 'แยก %{valueCount} จุดข้อมูล',

	// DB2 connection page
	'db2Database': 'ฐานข้อมูล DB2 (%{jdbcConnection})',
	'db2Title': 'เชื่อมต่อกับ IBM DB2',

	// Database
	'databaseConnectionMessage': 'ระบุรายละเอียดการเชื่อมต่อฐานข้อมูลของคุณ:',
	'connectionString': 'สตริงการเชื่อมต่อฐานข้อมูล',
	'databaseCredentials': 'หนังสือรับรอง: ',
	'databaseUserName': 'ชื่อผู้ใช้',
	'databasePassword': 'รหัสผ่าน',
	'databaseConnect': 'เชื่อมต่อ',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'ป้อนคำที่ค้นหา:',
	'twitterKeyword': 'คีย์เวิร์ด',
	'twitterSearch': 'ค้นหา',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'เราไม่สามารถสร้างมุมมอง: %{error}\nการดำเนินการล้มเหลว: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'ตัวกรองวิดเจ็ต',
	'missingColumn': 'ไม่มี: %{columnLabel}',
	'missingFiltering': 'ไม่มีตัวกรองบน ID คอลัมน์ต่อไปนี้:',
	'heatByLabel': 'ความร้อนตาม',
	'evColumns': 'คอลัมน์',
	'evLocalFilters': 'ตัวกรองโลคัล',
	'evExpand': 'ขยาย',
	'evFilterTooltip': 'ตัวกรอง',
	'evAdd': 'เพิ่มคอลัมน์',

	// Navigation View
	'navigationBack': 'ย้อนกลับ',

	// Pinning
	'contentPinFail': 'เราไม่สามารถรวบรวมเนื้อหาได้ โปรดลองอีกครั้งภายหลัง',
	'contentPinFailOld': 'เราไม่สามารถปักหมุดเนื้อหา โปรดลองอีกครั้งภายหลัง',

	// Layouts
	'dropZoneLabel': 'ปล่อยที่นี่เพื่อขยายให้มีขนาดสูงสุด',

	//Share
	'shareDefaultPageTitle': 'เพจ %{index}',

	'nextPage': 'เพจถัดไป',
	'previousPage': 'เพจก่อนหน้านี้',

	'assetAssembly': 'มุมมอง',

	'toolbar_save': 'บันทึก',
	'brgr_saveAs': 'บันทึกเป็น',
	'brgr_refresh': 'รีเฟรช',

	// Save
	'saving': 'กำลังบันทึก...',
	'save_success': 'บันทึกมุมมอของคุณแล้ว',
	'save_failure': 'ขออภัย ไม่สามารถบันทึกมุมมองของคุณ โปรดลองใหม่อีกครั้งในภายหลัง',
	'dashboard_save_success': 'บันทึกแดชบอร์ดของคุณแล้ว',

	'geminiLeave': 'คุณกำลังจะออกจาก IBM Watson Analytics',

	'warning': 'คำเตือน',
	'missingDataSetData': 'ข้อมูลสำหรับชุดข้อมูลนี้ไม่พร้อมใช้งาน รีเฟรชชุดข้อมูล หรือติดต่อผู้ดูแลระบบของคุณสำหรับการเข้าถึงแหล่งข้อมูล',

	// Calculations
	'error_calculation_in_use': 'การคำนวณที่ระบุใช้งานอยู่ และไม่สามารถลบได้',

	'resize': 'ปรับขนาด',
	'rotate': 'หมุน',
	'moveHandle': 'ย้ายวิดเจ็ต',
	'expandHandle': 'ขยาย',
	'panHandle': 'แพน',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'นำทางไปยัง',

	// Slide out titles
	'shapeSlideoutTitle': 'รูปทรง',
	'textSlideoutTitle': 'ข้อความ',
	'mediaSlideoutTitle': 'สื่อ',
	'visualizationSlideoutTitle': 'วิชวลไลเซชัน',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'JSON ที่เตรียมไว้ไม่ถูกต้อง โปรดดูล็อกข้อผิดพลาดสำหรับข้อมูลเพิ่มเติม',

	// Widget type labels
	'shape_label': 'รูปทรง',
	'image_label': 'อิมเมจ',
	'data_label': 'แผนภูมิ',
	'media_label': 'สื่อ',
	'text_label': 'ข้อความ',
	'embedMedia_label': 'สื่อ',
	'youtube_label': 'วิดีโอ YouTube',
	'webpage_label': 'เว็บเพจ',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'รูปทรง',
	'noExtraText_shape_numbered': 'รูปทรง (%{number})',
	'few_shape': 'กลุ่มของ %{count} รูปทรง',
	'many_shape': 'กลุ่มของ %{count} รูปทรง',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} อิมเมจ',
	'one_image_numbered': '%{text} อิมเมจ (%{number})',
	'noExtraText_image': 'อิมเมจ',
	'noExtraText_image_numbered': 'อิมเมจ (%{number})',
	'few_image': 'กลุ่มของ %{count} อิมเมจ',
	'many_image': 'กลุ่มของ %{count} อิมเมจ',
	'noExtraText_text': 'เท็กซ์บ็อกว่าง',
	'noExtraText_text_numbered': 'เท็กซ์บ็อกซ์ว่าง (%{number})',
	'few_text': 'กลุ่มของ %{count} เท็กซ์บ็อกซ์',
	'many_text': 'กลุ่มของ %{count} เท็กซ์บ็อกซ์',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'วิวเวอร์คิวบ์',
	'pacubeviewer_named': '%{name} วิวเวอร์คิวบ์',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} เทียบกับ %{row_level1} and %{column_level1} การอ้างอิงไขว้',
	'crosstab_opt_mapping_numbered': '%{values} เทียบกับ %{row_level1} และ %{column_level1} (%{number}) การอ้างอิงไขว้',
	'crosstab_has_mapping': '%{values} เทียบกับ %{row_level1} การอ้างอิงไขว้',
	'crosstab_has_mapping_numbered': '%{values} เทียบกับ %{row_level1} (%{number}) การอ้างอิงไขว้',
	'crosstab_no_mapping': 'การอ้างอิงไขว้ว่าง',
	'crosstab_no_mapping_numbered': 'การอ้างอิงไขว้ว่าง (%{number})',
	'crosstab_named': '%{name} การอ้างอิงไขว้',
	'crosstab_named_numbered': '%{name} การอ้างอิงไขว้ (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} ตาราง',
	'JQGrid_has_mapping_numbered': '%{grid_cols} ตาราง (%{number})',
	'JQGrid_no_mapping': 'ตารางว่าง',
	'JQGrid_no_mapping_numbered': 'ตารางว่าง (%{number})',
	'JQGrid_named': '%{name} ตาราง',
	'JQGrid_named_numbered': '%{name} ตาราง (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} ลำดับชั้น',
	'hierarchy_has_mapping_numbered': '%{level1} ลำดับชั้น (%{number})',
	'hierarchy_no_mapping': 'ลำดับชั้นว่าง',
	'hierarchy_no_mapping_numbered': 'ลำดับชั้นว่าง (%{number})',
	'hierarchy_named': '%{name} ลำดับชั้น',
	'hierarchy_named_numbered': '%{name} ลำดับชั้น (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} แม็พ',
	'map_has_mapping_numbered': '%{categories} แม็พ (%{number})',
	'map_no_mapping': 'แม็พว่าง',
	'map_no_mapping_numbered': 'แม็พว่าง (%{number})',
	'map_named': '%{name} แม็พ',
	'map_named_numbered': '%{name} แม็พ (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} ค่าสรุป',
	'summary_has_mapping_numbered': '%{actual} ค่าสรุป (%{number})',
	'summary_no_mapping': 'ค่าสรุปว่าง',
	'summary_no_mapping_numbered': 'ค่าสรุปว่าง (%{number})',
	'summary_named': '%{name} ค่าสรุป',
	'summary_named_numbered': '%{name} ค่าสรุป (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} ตาม %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} ตาม %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'KPI ว่าง',
	'kpi_no_mapping_numbered': 'KPI ว่าง (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} อินโฟกราฟิก',
	'infographicSummary_has_mapping_numbered': '%{actual} อินโฟกราฟิก (%{number})',
	'infographicSummary_no_mapping': 'อินโฟกราฟิกว่าง',
	'infographicSummary_no_mapping_numbered': 'อินโฟกราฟิกว่าง (%{number})',
	'infographicSummary_named': '%{name} อินโฟกราฟิก',
	'infographicSummary_named_numbered': '%{name} อินโฟกราฟิก (%{number})',
	'noExtraText_youtube': 'วิดีโอ YouTube',
	'noExtraText_youtube_numbered': 'วิดีโอ YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} วิดีโอ YouTube',
	'one_youtube_numbered': '%{text} วิดีโอ YouTube (%{number})',
	'few_youtube': 'กลุ่มของ %{count} วิดีโอ YouTube',
	'many_youtube': 'กลุ่มของ %{count} วิดีโอ YouTube',
	'noExtraText_embedMedia': 'ลิงก์สื่อบันทึก',
	'noExtraText_embedMedia_numbered': 'ลิงก์สื่อบันทึก (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} ลิงก์สื่อบันทึก',
	'one_embedMedia_numbered': '%{text} ลิงก์สื่อบันทึก (%{number})',
	'few_embedMedia': 'กลุ่มของ %{count} ลิงก์สื่อบันทึก',
	'many_embedMedia': 'กลุ่มของ %{count} ลิงก์สื่อบันทึก',
	'noExtraText_media': 'สื่อบันทึก',
	'noExtraText_media_numbered': 'สื่อบันทึก (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} สื่อบันทึก',
	'one_media_numbered': '%{text} สื่อบันทึก (%{number})',
	'few_media': 'กลุ่มของ %{count} สื่อบันทึก',
	'many_media': 'กลุ่มของ %{count} สื่อบันทึก',
	'noExtraText_webpage': 'เว็บเพจ',
	'noExtraText_webpage_numbered': 'เว็บเพจ (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} เว็บเพจ',
	'one_webpage_numbered': '%{text} เว็บเพจ (%{number})',
	'few_webpage': 'กลุ่มของ %{count} เว็บเพจ',
	'many_webpage': 'กลุ่มของ %{count} เว็บเพจ',
	'one_unknown': 'อ็อบเจ็กต์',
	'one_unknown_numbered': 'อ็อบเจ็กต์ (%{number})',
	'few_unknown': 'กลุ่มของ %{count} อ็อบเจ็กต์',
	'many_unknown': 'กลุ่มของ %{count} อ็อบเจ็กต์',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'ถัดไป',
	'previous': 'ก่อนหน้า',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'กลุ่มการนำทางปัจจุบันคือ %{navigation_group_name}',

	//Page Context
	'filterBlank': '(ว่าง)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'ไม่สามารถโหลดค่าตัวกรองได้',
	'editTimelineHighlight': 'แก้ไขไฮไลต์',

	'filterDockChevronLeft': 'เลื่อนผ่านข้อมูล',
	'filterDockChevronRight': 'เลื่อนผ่านข้อมูล',
	'expand': 'ขยาย',
	'collapse': 'ยุบ',

	//Reset Dashboard
	'dashboardResetTitle': 'รีเซ็ตแดชบอร์ด',
	'dashboardResetMessage': 'คุณแน่ใจว่าต้องการรีเซ็ตการเปลี่ยนแปลงทั้งหมดที่นำไปใช้กับแดชบอร์ดนี้หรือไม่',
	'dashboardResetToast': 'แดชบอร์ดของคุณถูกรีเซ็ตแล้ว',

	//Generate PDF
	'buildingPDF': 'กำลังบิวด์ PDF...',
	'exportPDF': 'เอ็กซ์พอร์ตเป็น PDF',
	'pageSize': 'ขนาดเพจ',
	'orientation': 'การจัดวาง',
	'filtersPresentPDF': 'ตัวกรองที่นำมาใช้กับวิชวลไลเซชันในเพจก่อนหน้า:',
	'errorPDF': 'ไม่สามารถสร้าง PDF โปรดรีเฟรชและลองใหม่อีกครั้ง',
	'printPDFInfo': 'ดูเอกสารคู่มือ',
	'pdfWidget': 'วิดเจ็ต',
	'includeFilters': 'แสดงรายละเอียดของตัวกรอง',
	'portrait': 'แนวตั้ง',
	'landscape': 'แนวนอน',
	'letter': 'จดหมาย',
	'legal': 'ถูกกฎหมาย',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'แดชบอร์ดของคุณถูกอัพเกรดแล้ว บันทึกเดี๋ยวนี้เพื่อรักษาประสิทธิภาพสูงสุด',

	'ariaFullScreenMessage': 'กด Escape เพื่อออกจากการแสดงแบบเต็มหน้าจอ',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} แผนภูมิบับเบิลลำดับชั้นแบบแพ็ค',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} แผนภูมิบับเบิลลำดับชั้นแบบแพ็ค (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'แผนภูมิบับเบิลลำดับชั้นแบบแพ็กว่าง',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'แผนภูมิบับเบิลลำดับชั้นแบบแพ็คว่าง (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} แผนภูมิบับเบิลลำดับชั้นแบบแพ็ค',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} แผนภูมิบับเบิลลำดับชั้นแบบแพ็ค (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} เทียบกับ %{values} แผนภูมิ marimekko',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} เทียบกับ %{values} แผนภูมิ marimekko (%{number})',
	'LIVE_marimekko_no_mapping': 'แผนภูมิ marimekko ว่าง',
	'LIVE_marimekko_no_mapping_numbered': 'แผนภูมิ marimekko ว่าง (%{number})',
	'LIVE_marimekko_named': '%{name} แผนภูมิ marimekko',
	'LIVE_marimekko_numbered': '%{name} แผนภูมิ marimekko (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} แผนภูมิแสงกระจาย',
	'LIVE_sunburst_has_mapping_numbered': '%{values} แผนภูมิแสงกระจาย (%{number})',
	'LIVE_sunburst_no_mapping': 'แผนภูมิแสงกระจายว่าง',
	'LIVE_sunburst_no_mapping_numbered': 'แผนภูมิแสงกระจายว่าง (%{number})',
	'LIVE_sunburst_named': '%{name} แผนภูมิแสงกระจายว่าง',
	'LIVE_sunburst_named_numbered': '%{name} แผนภูมิแสงกระจายว่าง (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} แผนภูมิการวิเคราะห์ไดรเวอร์',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} แผนภูมิการวิเคราะห์ไดรเวอร์ (%{number})',
	'LIVE_decision_analysis_no_mapping': 'แผนภูมิการวิเคราะห์ไดรเวอร์ว่าง',
	'LIVE_decision_analysis_no_mapping_numbered': 'แผนภูมิการวิเคราะห์ไดรเวอร์ว่าง (%{number})',
	'LIVE_decision_analysis_named': '%{name} แผนภูมิการวิเคราะห์ไดรเวอร์',
	'LIVE_decision_analysis_named_numbered': '%{name} แผนภูมิการวิเคราะห์ไดรเวอร์ (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} by %{columnValue} และ %{lineValue} แผนภูมิเส้นและคอลัมน์',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} เทียบกับ %{columnValue} และ %{lineValue} แผนภูมิเส้นและคอลัมน์ (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} และ %{lineValue} แผนภูมิเส้นและคอลัมน์',
	'LIVE_line_column_has_mapping_numbered': '%{categories} เทียบกับ %{columnValue} และ %{lineValue} แผนภูมิเส้นและคอลัมน์ (%{number})',
	'LIVE_line_column_no_mapping': 'แผนภูมิเส้นและคอลัมน์ว่าง',
	'LIVE_line_column_no_mapping_numbered': 'แผนภูมิเส้นและคอลัมน์ว่าง (%{number})',
	'LIVE_line_column_named': '%{name} แผนภูมิเส้นและคอลัมน์',
	'LIVE_line_column_named_numbered' : '%{name} แผนภูมิเส้นและคอลัมน์ (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} เทียบกับ %{y} และ %{size} แผนภูมิบับเบิล',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} เทียบกับ %{y} และ %{size} แผนภูมิบับเบิล (%{number})',
	'LIVE_bubble_chart_no_mapping': 'แผนภูมิบับเบิลว่าง',
	'LIVE_bubble_chart_no_mapping_numbered': 'แผนภูมิบับเบิลว่าง (%{number})',
	'LIVE_bubble_chart_named': '%{name} แผนภูมิบับเบิลว่าง',
	'LIVE_bubble_chart_named_numbered': '%{name} แผนภูมิบับเบิลว่าง (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} แผนภูมิสัญลักษณ์แสดงหัวข้อย่อย',
	'LIVE_bullet_has_mapping_numbered': '%{actual} แผนภูมิสัญลักษณ์แสดงหัวข้อย่อย (%{number})',
	'LIVE_bullet_no_mapping': 'แผนภูมิสัญลักษณ์แสดงหัวข้อย่อยว่าง',
	'LIVE_bullet_no_mapping_numbered': 'แผนภูมิสัญลักษณ์แสดงหัวข้อย่อยว่าง (%{number})',
	'LIVE_bullet_named': '%{name} แผนภูมิสัญลักษณ์แสดงหัวข้อย่อย',
	'LIVE_bullet_named_numbered': '%{name} แผนภูมิสัญลักษณ์แสดงหัวข้อย่อย (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'ข้อมูลบนแดชบอร์ดนี้จัดเตรียมโดย',
	'showFooterToggleButtonText': 'แสดงส่วนท้าย',
	'showFooterSectionText': 'ส่วนท้าย'
});
